'use strict';

var baggageObserverMixin = require('../../modules/mixins/baggages_observer.mixin');
var BaggageSummaryWidget = Odigeo.Widget.extend(baggageObserverMixin.extend({
    viewClass: require('./view'),
    init: function() {
        this.options = Odigeo.Utils.parseOptions(this.options);
        this.suscribeBaggagesCollectionEvents();
    },
    onCollectionBuilt: function() {
        this.view.onUpdateBaggages();
        this.view.enhanceBaggageFeeTooltip();
    },
    onBaggageChange: function(changedModel) {
        var selectedAttribute = changedModel.currentOption.get('selected');

        if (selectedAttribute) {
            this.view.onUpdateBaggages();
        }
    },
}));

Odigeo.defineWidget('baggage_summary', BaggageSummaryWidget);
